/**
 * Get font size from the theme for a title size
 */
const getFontSize = p => {
  const fontSizes = p.theme.fontSizes;
  return fontSizes[fontSizes.length - Number(p.size)] || fontSizes[fontSizes.length - 1];
};

export default getFontSize;
